import { toPng, toBlob } from "html-to-image";

import { showSuccessToast, showErrorToast } from "./show-toast";
import Logger from "./logger";

export async function getFileBlob(
  htmlNode: HTMLElement | null
): Promise<Blob | null> {
  if (!htmlNode) return null;
  try {
    return await toBlob(htmlNode, { cacheBust: true });
  } catch (e) {
    Logger.error(e);
    showErrorToast("Error generating file blob");
    return null;
  }
}

export async function downloadPngImageFromDomContent(
  htmlNode: HTMLElement | null,
  fileName: string
) {
  if (!htmlNode) return;
  try {
    const dataUrl = await toPng(htmlNode, { cacheBust: true });
    const link = document.createElement("a");
    link.download = `${fileName || "image"}.png`;
    link.href = dataUrl;
    link.click();
    showSuccessToast("Image downloaded");
  } catch (e) {
    Logger.error(e);
    showErrorToast("Error downloading image");
  }
}
